// Guard durable para emitir `survey_shown` UNA sola vez por (comercio, encuesta). Mismo patrón
// que GaAnnouncementBanner.dismissKey: llave dedicada en localStorage que resetStore(login) NO
// borra, keyed por commerce_id + announcement_uuid. Sin esto, cada navegación que remonta el
// anuncio inflaría el conteo de impresiones (denominador del response_rate).

const SHOWN_PREFIX = 'plick:survey-shown:v1:';

const getActiveCommerceId = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem('id_commerce');
  } catch {
    return null;
  }
};

const shownKey = (commerceId: string, announcementUuid: string): string =>
  `${SHOWN_PREFIX}${commerceId}:${announcementUuid}`;

// True si ya se emitió survey_shown para este comercio+encuesta (no volver a emitir).
export const wasSurveyShown = (announcementUuid: string): boolean => {
  if (typeof window === 'undefined') return false;
  const commerceId = getActiveCommerceId();
  if (!commerceId) return false;
  try {
    return window.localStorage.getItem(shownKey(commerceId, announcementUuid)) === '1';
  } catch {
    return false;
  }
};

// Marca survey_shown como emitido. Devuelve true si ESTA llamada fue la que lo marcó (es decir,
// no estaba marcado antes) → el caller emite el evento solo cuando recibe true (claim atómico).
export const claimSurveyShown = (announcementUuid: string): boolean => {
  if (typeof window === 'undefined') return false;
  const commerceId = getActiveCommerceId();
  if (!commerceId) return false;
  try {
    const key = shownKey(commerceId, announcementUuid);
    if (window.localStorage.getItem(key) === '1') return false;
    window.localStorage.setItem(key, '1');
    return true;
  } catch {
    // Sin localStorage (modo privado / quota): degradar a "emitir" para no perder la señal.
    return true;
  }
};
